import { render, staticRenderFns } from "./SalesBanner.vue?vue&type=template&id=49a9e754&"
import script from "./SalesBanner.vue?vue&type=script&lang=js&"
export * from "./SalesBanner.vue?vue&type=script&lang=js&"
import style0 from "./SalesBanner.vue?vue&type=style&index=0&id=49a9e754&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports